var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('SectionBanner'),_c('SectionPhilosophy'),_c('SectionProgrammesAndWorkshop'),_c('SectionAdmission'),_c('SectionContactUs')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }